import { render, staticRenderFns } from "./Transfer_goods_add.vue?vue&type=template&id=1f04bab3&scoped=true&"
import script from "./Transfer_goods_add.vue?vue&type=script&lang=js&"
export * from "./Transfer_goods_add.vue?vue&type=script&lang=js&"
import style0 from "./Transfer_goods_add.vue?vue&type=style&index=0&id=1f04bab3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f04bab3",
  null
  
)

export default component.exports